import React, { useEffect } from "react";
import img from "../../../Home/img_project/webp/34Plafond architectural moderne.webp";

const Block = ({ title, children }) => (
  <section className="pj-block">
    <h2>{title}</h2>
    <div className="pj-block-content">{children}</div>
  </section>
);

export default function ProjectGrandTheatre() {

  useEffect(() => {
    document.title =
      "Grand Théâtre Mohammed VI – Plafond architectural | UNIK SYSTEM";

    let meta = document.querySelector("meta[name='description']");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.setAttribute(
      "content",
      "Plafond rétro-éclairé de plus de 2 000 m² pour le Grand Théâtre Mohammed VI. Solution en toiles translucides pour un projet architectural emblématique."
    );
  }, []);

  return (
    <div className="pj-page">

      {/* HERO */}
      <section className="pj-hero">
        <div className="pj-hero-text">
          <span className="pj-badge">PROJET RÉFÉRENCE</span>

          <h1>
            Grand Théâtre Mohammed VI <br /> Plafond architectural
          </h1>

          <p>
            Réalisation d’un plafond rétro-éclairé de plus de 2 000 m²
            pour un projet architectural emblématique, alliant design
            contemporain et performance technique.
          </p>

          <p className="pj-sub">
            Solutions UNIK SYSTEM : toiles translucides,
            architecture de prestige.
          </p>

          <div className="pj-hero-actions">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-projet-grand-theatre.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche projet
            </a>
          </div>
        </div>

        <div className="pj-hero-img">
          <img src={img} alt="Grand Théâtre Mohammed VI plafond architectural" />
        </div>
      </section>

      {/* CONTEXTE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Contexte du projet</span>}>
        <p>
          Réalisation d’un plafond architectural rétro-éclairé dans
          le Grand Théâtre Mohammed VI, un bâtiment culturel
          emblématique à forte valeur architecturale.
        </p>
        <p>
          Le projet nécessitait une solution esthétique, durable et
          techniquement performante pour couvrir une surface
          supérieure à 2 000 m².
        </p>
      </Block>

      {/* SOLUTIONS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Solutions UNIK SYSTEM</span>}>
        <ul className="pj-list">
          <li>Plafond rétro-éclairé de grande dimension</li>
          <li>Toiles translucides haute performance</li>
          <li>Diffusion lumineuse homogène</li>
          <li>Structure aluminium technique</li>
          <li>Intégration architecturale sur mesure</li>
        </ul>
      </Block>

      {/* RESULTATS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Résultats obtenus</span>}>
        <ul className="pj-list">
          <li>Signature architecturale forte</li>
          <li>Ambiance lumineuse homogène</li>
          <li>Valorisation de l’espace intérieur</li>
          <li>Solution durable et performante</li>
          <li>Projet emblématique réalisé</li>
        </ul>
      </Block>

      {/* GALERIE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Galerie projet</span>}>
        <div className="pj-gallery">
          <img src={img} alt="" />
          <img src={img} alt="" />
          <img src={img} alt="" />
        </div>
      </Block>

      {/* CTA */}
      <section className="pj-cta">
        <h2>Vous avez un projet similaire ?</h2>
        <p>
          Notre équipe technique vous accompagne de la conception à la pose.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
